<template>
  <b-modal
    size="xl"
    ok-title="Confirm"
    title="Confirm would you like to cancel this case"
    title-tag="h5"
    cancel-title="Cancel"
    cancel-variant="outline-primary"
    id="idCancelSurgicalCasedModal"
    :ok-disabled="cancelReason === 'Other' ? !cancelComment : !cancelReason"
    @ok="onOk"
    @hidden="onHidden"
  >
    <div class="padding">
      <b-row>Please provide a reason for this cancellation</b-row>
      <b-row>
        <label for="idTreatmentDetailsProcedure">Reason</label>
        <b-form-select
          size="sm"
          required
          id="idCancelReason"
          v-model="cancelReason"
          :options="cancelReasonOptions"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" disabled>-Select-</b-form-select-option>
          </template>
        </b-form-select>
      </b-row>
      <b-row v-if="cancelReason === 'Other'">
        <label for="idCancelComment">Cancel Comment</label>
        <b-form-textarea
          id="idCancelComment"
          v-model="cancelComment"
          required
          rows="3"
          max-rows="3"
    ></b-form-textarea>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      cancelComment: "",
      cancelReason: null,
      cancelReasonOptions: [
        "Insurance",
        "Medical clearance",
        "Patient No-Show",
        "Facility issue",
        "Patient Sick",
        "Hospital / Surgeon Cancelled",
        "Hospital / Surgeon Rescheduled",
        "Other",
        "Reschedule Event",
        "Lack of Inventory"
      ]
    };
  },
  props: ["surgicalCaseId"],

  methods: {
    onOk() {
     const reason = this.cancelReason === "Other" ? this.cancelComment : this.cancelReason
     this.$emit('caseCancelled', reason)
    },
    onHidden(){
      this.cancelReason = null
    }
  }
};
</script>

<style scoped>
.padding {
  padding: 1rem 3rem;
}
.row {
  margin-top: 1rem
}
</style>